import { render, staticRenderFns } from "./MoneyBack.vue?vue&type=template&id=234490c8&scoped=true"
var script = {}
import style0 from "./MoneyBack.vue?vue&type=style&index=0&id=234490c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234490c8",
  null
  
)

export default component.exports